import {
    Minus,
    Plus,
    Trash2,
    LoaderCircle,
} from "lucide-react";

import { useCart } from "../../context/CartContext";

export default function CartQuantityControl({
    product,
}) {

    const {
        getCartItem,
        increaseQty,
        decreaseQty,
        removeFromCart,
        isValidating,
    } = useCart();


    const cartItem = getCartItem(
        product.id,
        product.variationId
    );


    /*
    |--------------------------------------------------------------------------
    | Product is not in cart
    |--------------------------------------------------------------------------
    |
    | Don't show quantity selector.
    |
    */

    if (!cartItem) {

        return null;

    }


    const isLoading = isValidating(
        product.id,
        product.variationId
    );


    const quantity =
        Number(cartItem.qty);


    const handleDecrease = () => {

        if (quantity === 1) {

            removeFromCart(
                product.id,
                product.variationId
            );

            return;
        }

        decreaseQty(
            product.id,
            product.variationId
        );

    };


    return (

        <div className="cart-control-wrapper">



            <button
                type="button" className="cart-control-wrapper-btn"
                onClick={() =>
                    increaseQty(
                        product.id,
                        product.variationId
                    )
                }
                disabled={isLoading}
            >

                <Plus size={16} />

            </button>

            <span className="cart-quantity-card">

                {isLoading ? (

                    <LoaderCircle
                        size={17}
                        className="quantity-spinner"
                    />

                ) : (

                    quantity

                )}

            </span>



            <button className={`quantity-btn ${quantity === 1 ? "remove-btn" : ""
                }`}
                type="button"
                onClick={handleDecrease}
                disabled={isLoading}
            >

                  {quantity === 1 ? (
                    <Trash2 size={16} />
                ) : (
                    <Minus size={16} />
                )}

            </button>

        </div>

    );

}